<template>
  <div :id="componentId" class="spm1-panel" :style="{ backgroundColor }">
    <div class="spm1-panel-image-wrap">
      <a
        v-if="currentItem.jumpType === 1"
        class="spm1-panel-image-link"
        href="javascript:;"
        @click.prevent="goArticle(currentItem.linkAddress)"
      >
        <img class="spm1-panel-image" referrerpolicy="no-referrer" :src="currentItem.imageUrl" />
      </a>
      <a
        v-else-if="currentItem.jumpType === 2"
        class="spm1-panel-image-link"
        :href="currentItem.linkAddress"
        target="_blank"
      >
        <img class="spm1-panel-image" referrerpolicy="no-referrer" :src="currentItem.imageUrl" />
      </a>
      <div v-else class="spm1-panel-image-link">
        <img class="spm1-panel-image" referrerpolicy="no-referrer" :src="currentItem.imageUrl" />
      </div>
      <!-- 底部渐变 + 指示器 -->
      <div class="spm1-panel-overlay">
        <span
          v-for="(item, idx) in items"
          :key="idx"
          class="spm1-panel-dot"
          :class="{ 'spm1-panel-dot--active': idx === itemIndex }"
          @click="goTo(idx)"
        ></span>
        <span class="spm1-panel-number">{{ padNumber }}</span>
      </div>
    </div>
    <div class="spm1-panel-content">
      <div class="spm1-panel-text-group">
        <a
          v-if="currentItem.jumpType === 1"
          class="spm1-panel-title link-title"
          href="javascript:;"
          @click.prevent="goArticle(currentItem.linkAddress)"
        >{{ currentItem.articleTitle }}</a>
        <a
          v-else-if="currentItem.jumpType === 2"
          class="spm1-panel-title link-title"
          :href="currentItem.linkAddress"
          target="_blank"
        >{{ currentItem.articleTitle }}</a>
        <span v-else class="spm1-panel-title">{{ currentItem.articleTitle }}</span>
        <span class="spm1-panel-subtitle">{{ currentItem.subtitle }}</span>
      </div>
      <span class="spm1-panel-summary">{{ currentItem.articleSummary }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileHeroCarouselPanel',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_3'
    }
  },
  data() {
    return {
      itemIndex: 0,
      items: [
        {
          imageUrl: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG9161e8183223beabf04871a363a490c5.png'),
          articleNumber: 1,
          newsCode: '19299356',
          articleTitle: '第七届中国品牌发展论坛系列活动现场花絮!',
          subtitle: '浙江大学CARD中国农业品牌研究中心主任胡晓云',
          articleSummary: '创造品牌经济有三大特征：第一个特征是提升实体经济价值的符号经济。第二是增加资源经济价值的关系经济。第三是以产品与符号的意义为价值的价值经济。',
          jumpType: 1,
          linkAddress: '/zp/a/19299356'
        },
        {
          imageUrl: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG9161e8183223beabf04871a363a490c5.png'),
          articleNumber: 2,
          newsCode: '19299357',
          articleTitle: '区域农业品牌发展论坛在京成功举办',
          subtitle: '《中国品牌》杂志社社长张超',
          articleSummary: '本次活动聚焦区域农业品牌高质量发展，邀请业内专家、地方政府代表及企业代表共同探讨品牌建设新路径。',
          jumpType: 2,
          linkAddress: 'https://www.example.com/article/2'
        },
        {
          imageUrl: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG9161e8183223beabf04871a363a490c5.png'),
          articleNumber: 3,
          newsCode: '19299358',
          articleTitle: '2025区域农业品牌年度盛典即将启幕',
          subtitle: '中国品牌网',
          articleSummary: '年度盛典将汇聚全国优质区域农业品牌，展示品牌建设成果，搭建交流合作平台。',
          jumpType: 1,
          linkAddress: '/zp/a/19299356'
        }
      ],
      backgroundColor: 'rgba(255, 255, 255, 1)',
      timer: null,
      interval: 4000
    }
  },
  computed: {
    currentItem() {
      return this.items[this.itemIndex] || this.items[0]
    },
    padNumber() {
      return String(this.itemIndex + 1).padStart(2, '0')
    }
  },
  mounted() {
    this.startAutoPlay()
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    startAutoPlay() {
      this.stopAutoPlay()
      this.timer = setInterval(() => {
        this.nextItem()
      }, this.interval)
    },
    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    restartAutoPlay() {
      this.startAutoPlay()
    },
    prevItem() {
      this.itemIndex = (this.itemIndex - 1 + this.items.length) % this.items.length
      this.restartAutoPlay()
    },
    nextItem() {
      this.itemIndex = (this.itemIndex + 1) % this.items.length
    },
    goTo(idx) {
      this.itemIndex = idx
      this.restartAutoPlay()
    },
    goArticle(path) {
      if (!path) return
      if (path.startsWith('http')) {
        window.open(path, '_blank')
        return
      }
      // jumpType 为 1 时，如果 path 是 /detail?newsCode=xxx 则直接跳转
      // 如果只是 newsCode，则转换为完整路径
      if (this.currentItem.jumpType === 1 && !path.includes('?')) {
        const newsCode = this.currentItem.articleNumber
        if (newsCode) {
          this.$router.push(`/detail?newsCode=${newsCode}`)
          return
        }
      }
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
.spm1-panel {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.spm1-panel-image-wrap {
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
  border-radius: 8px;
}

.spm1-panel-image-link {
  display: block;
  width: 100%;
  height: 100%;
}

.spm1-panel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.spm1-panel-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  padding: 0 12px;
  box-sizing: border-box;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
}

.spm1-panel-overlay .spm1-panel-dot {
  width: 20px;
  height: 3px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 2px;
  margin-right: 6px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.spm1-panel-overlay .spm1-panel-dot--active {
  background-color: rgba(255, 255, 255, 1);
}

.spm1-panel-number {
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  white-space: nowrap;
  line-height: 20px;
  margin-left: auto;
}

.spm1-panel-content {
  margin-top: 12px;
}

.spm1-panel-text-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.spm1-panel-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  line-height: 22px;
}

.link-title {
  cursor: pointer;
}

.spm1-panel-subtitle {
  font-size: 13px;
  color: #666;
  line-height: 18px;
}

.spm1-panel-summary {
  display: -webkit-box;
  margin-top: 8px;
  font-size: 13px;
  color: #999;
  line-height: 20px;
  height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

</style>
